// components/Naray8/ui/StoryCard.jsx
import { IoEye } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetter, formatNumber } from "../../../utils/stringUtils";
import { FaStar } from "react-icons/fa";
import { useSelector } from "react-redux";

// const narrate = {
//   "narrateId": "e6a5e435-61a7-40b2-806e-5e4185ae36ee",
//   "userId": "d874231b-161c-4dba-b4fd-ee65191f6f43",
//   "genre": "history",
//   "title": "Shadows of the Second War",
//   "status": "published",
//   "contentStatus": "ongoing",
//   "coverImage": "https://bd-bucket-2.s3.af-south-1.amazonaws.com/narrate/4f6b982eba6950cff34b7cf16ca3e825323a0e39ac4cb4dc3bd6292bce4a39f2",
//   "imageName": "4f6b982eba6950cff34b7cf16ca3e825323a0e39ac4cb4dc3bd6292bce4a39f2",
//   "category": "history",
//   "explicitLanguage": false,
//   "violentThemes": false,
//   "adultContent": false,
//   "tags": [
//     "World War II",
//     "History",
//     "War",
//     "Global conflicts",
//     "Soldiers",
//     "1940s",
//     "Survival"
//   ],
//   "ratings": 0,
//   "viewCount": 11,
//   "mainCharacters": [
//     "Adolf Hitler",
//     "Winston Churchill",
//     "Franklin D. Roosevelt",
//     "Joseph Stalin (USSR)",
//     "Private Thomas “Tom” O’Malley",
//     "Captain Hans Bauer – German Officer",
//     "I"
//   ],
//   "ratedBy": [],
//   "totalChapters": 1,
//   "description": "A sweeping, omniscient narrative of World War II, Shadows of the Second War captures the lives of soldiers, civilians, and leaders across continents. From the rise of totalitarian regimes to the battlefields of Europe, Africa, and the Pacific, to the cities and homes reshaped by conflict, this book tells the human story behind history’s deadliest war. Heroes, victims, and ordinary people alike navigate fear, courage, and survival as the world is consumed by fire, ideology, and ambition",
//   "createdAt": "2026-01-12T17:39:22.961Z",
//   "updatedAt": "2026-01-26T15:52:50.269Z",
//   "user": {
//     "userId": "d874231b-161c-4dba-b4fd-ee65191f6f43",
//     "firstName": "Onimole",
//     "lastName": "Tosin",
//     "profilePhoto": [
//       {
//         "photoPublicUrl": "https://bd-bucket-2.s3.af-south-1.amazonaws.com/f5c3402aedd09cacd51484bda2b4c9789a3e3ca9d2b1e48c91d105f4d561d0bf"
//       }
//     ]
//   },
//   "chapters": [
//     {
//       "chapterId": "b26d7f0b-1b59-497b-a33f-723233442de1",
//       "chapterNumber": 1,
//       "title": "Prologue"
//     }
//   ]
// }

export default function StoryCard({ narrate, story = {}, index, animateEntry }) {
  const navigate = useNavigate();
  const correctedVariable = {
    narrateId: story.id,
    title: story.tilte,
    user: { firstName: story.author, lastName: "", userId: "test user" },
    coverImage: story.cover,
    ratings: story.rating,
    totalChapters: story.chapters,
    viewCount: story.reads,
    tags: story.genres
  }
  const myId = useSelector((state) => state.user?.userData?.userId);
  const { title, ratings, coverImage, user, tags, totalChapters, narrateId, viewCount } = narrate ?? correctedVariable
  const { firstName, lastName, userId } = user ?? {}
  const isAuthUser = userId === myId;
  const authorName = `${firstName} ${lastName}`.trim()

  const handleCardClick = () => {
    if (narrateId) {
      // Navigate to the story detail page within Naray8
      navigate(`/naray8/b/${narrateId}`);
    }
  };

  return (
    <div
      className="bg-[#1C1B19] rounded-[10px] group hover:shadow-black/60 transition-all duration-300 overflow-hidden relative w-full flex flex-col cursor-pointer shadow-black/25 shadow-xl pb-[5px]"
      style={(animateEntry && index) ?
        {
          animation: `fadeScaleSlide 0.5s ease forwards`,
          animationDelay: `${index * 100}ms`,
          opacity: 0,
          transform: "translateY(20px) scale(0.95)",
        } : undefined
      }
      onClick={handleCardClick}
    >
      {/* Rating Badge */}
      <div className="absolute flex items-center gap-x-1 top-2 right-2 bg-[#353530] text-[6px] px-2 py-0.5 font-sora rounded-[1px] z-10">
        <FaStar size={8} className="text-[#FFBC00]" />
        <p className="mb-[-1px]">{ratings}</p>
      </div>

      {/* Cover Image */}
      <div className="w-full aspect-[92/100] overflow-hidden">
        <img
          src={coverImage}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>

      {/* Content */}
      <div className="p-1.5 flex flex-col gap-0.5">
        <h3 title={title} className="text-white font-semibold font-sora text-[10px] leading-3 line-clamp-1 text-ellipsis">
          {title}
        </h3>
        <p
          onClick={(e) => {
            e.stopPropagation();
            if(userId === "test user") return;  
            navigate(isAuthUser ? "/naray8/writer/me" : `/naray8/writer/${userId}`)
          }}
          title={authorName}
          className="text-gray-400 text-[8px] leading-[15px] -mb-[1px] line-clamp-1 hover:underline"
        >
          {authorName}
        </p>

        {/* Tags */}
        <div className="flex gap-[3px] mb-1 flex-wrap">
          {tags?.slice(0, 2)?.map((tag, index) => (
            <span
              key={index}
              className="text-customDark font-sora font-semibold bg-[#9B9B9B] text-[6px] px-2 py-[2px] rounded-[2px]"
            >
              {capitalizeFirstLetter("narrate")?.trim()}
            </span>
          ))}
          {tags?.length > 2 && (
            <span className="text-gray-300 font-sora font-semibold bg-[#353530] text-[8px] px-3 rounded-full">
              +{tags?.length - 2}
            </span>
          )}
        </div>

        {/* Stats Row */}
        <div className="flex justify-between items-center text-gray-400 font-sora text-[8px]">
          <span>{totalChapters} chapters</span>
          <div className="flex items-center gap-1">
            <IoEye size={10} />
            <span>{formatNumber(viewCount || 0)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}